export default __webpack_public_path__ + "static/media/search-icon.52e36301.svg";